var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { LanguagesCore } from '@core-front/languages';
import Anchor from '@telia-front/anchor';
import { List, ListItem } from '@telia-front/list';
const Languages = (props) => {
    const { theme } = props, rest = __rest(props, ["theme"]);
    const LanguagesAnchor = React.useCallback((anchorProps) => (React.createElement(Anchor, Object.assign({}, anchorProps, { theme: theme, isTextColor: theme === 'dark' ? false : anchorProps.isTextColor, className: theme === 'dark' ? 'text-primary-dark text-weight-normal' : 'text-weight-normal' }))), [theme]);
    const LanguagesList = React.useCallback((listProps) => React.createElement(List, Object.assign({}, listProps, { theme: theme })), [theme]);
    return (React.createElement(LanguagesCore, Object.assign({}, rest, { components: {
            Anchor: LanguagesAnchor,
            List: LanguagesList,
            ListItem,
        } })));
};
export default Languages;
